import * as Yup from 'yup';

export const FREE_BUSY = Yup.object().shape({
  start: Yup.date().required(),
  end: Yup.date().required(),
  off: Yup.boolean().default(false),
  busy: Yup.boolean().default(false),
})